import { create } from 'zustand';

/**
 * Transient app-shell UI state for chrome shared across screens. `TabShell`
 * owns the scroll signal; shared headers consume the compact/full state.
 */
interface UiState {
  navDrawerOpen: boolean;
  headerCollapsed: boolean;
  currentPath: string | null;
  previousPath: string | null;
  setNavDrawerOpen: (open: boolean) => void;
  setHeaderCollapsed: (collapsed: boolean) => void;
  trackPath: (path: string) => void;
  openNavDrawer: () => void;
}

export const useUiStore = create<UiState>((set) => ({
  navDrawerOpen: false,
  headerCollapsed: false,
  currentPath: null,
  previousPath: null,
  setNavDrawerOpen: (navDrawerOpen) => set({ navDrawerOpen }),
  setHeaderCollapsed: (headerCollapsed) => set({ headerCollapsed }),
  trackPath: (path) =>
    set((state) => {
      if (state.currentPath === path) return state;
      return {
        previousPath: state.currentPath,
        currentPath: path,
      };
    }),
  openNavDrawer: () => set({ navDrawerOpen: true }),
}));
